
// import img1 from '../images/slider/img-slider-3.jpg'
import img1 from '../images/vam/1.png'
import img2 from '../images/slider/img-slider-4.jpg'
import img3 from '../images/slider/img-slider-5.jpg'
import avt1 from '../images/avatar/avt-8.jpg'
import avt2 from '../images/avatar/avt-9.jpg'
import avt3 from '../images/avatar/avt-10.jpg'
import avt4 from '../images/avatar/avt-11.jpg'
import img5 from '../images/store/vam.png'

const dataSlider2 = [
    {
        title: "Discover and collect your favorite digital NTFs",
        description: "Quis autem vel eum iure reprehenderit qui in ea voluptates esse quam nihil molestiae consequatur veillum",
        img1: img1,
        img2: img2,
        img3: img3,
        avt1: avt1,
        avt2: avt2,
        avt3: avt3,
        avt4: avt4,
    },
     {
        title: "VAMStack",
        description: "Video Analytics Management (called VAM) is the powerful and flexible platform being suitable for various industry areas such as home/office and retails/shops etc.",
        img: img5,
    },
    
]

export default dataSlider2;